import React from 'react';
import { Container, Grid } from '@mui/material';
import LinkButtonCard from '../../components/shared/link-button-card';
import { useGlobalState } from '../../global/context/global-context';
import { HomeSectionTitle, PageSection } from '../home.styles';

// Material-UI Icons
import NewspaperIcon from '@mui/icons-material/Newspaper';
import GavelIcon from '@mui/icons-material/Gavel';
import SearchIcon from '@mui/icons-material/Search';
import ReceiptIcon from '@mui/icons-material/Receipt';
import PaymentIcon from '@mui/icons-material/Payment';
import FlightIcon from '@mui/icons-material/Flight';
import TrendingUpIcon from '@mui/icons-material/TrendingUp';
import MoneyOffIcon from '@mui/icons-material/MoneyOff';
import InfoIcon from '@mui/icons-material/Info';
import RecordVoiceOverIcon from '@mui/icons-material/RecordVoiceOver';
import DescriptionIcon from '@mui/icons-material/Description';
import FolderOpenIcon from '@mui/icons-material/FolderOpen';
import BalanceIcon from '@mui/icons-material/Balance';
import { ouvUrl, sicUrl } from '../../../utils/environment';

interface QuickAccessItem {
  title: string;
  href: string;
  icon: React.ReactNode;
  external?: boolean;
  disabled?: boolean;
}

export default function SectionQuickAccess() {
  const { applicationData, parametersPortal } = useGlobalState();
  const cnpj = applicationData?.entity?.document || '';

  // Gera o nome da cidade sem espaços para o SEI
  const cityNameNoSpaces = applicationData?.entity?.address?.city
    ?.toLowerCase()
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '') // Remove acentos
    .replace(/\s+/g, '') // Remove espaços
    || '';

  const accessItems: QuickAccessItem[] = [
    {
      title: 'Diário Oficial',
      href: '/diario-oficial',
      icon: <NewspaperIcon />,
      external: false,
    },
    {
      title: 'Licitações',
      href: '/licitacoes',
      icon: <GavelIcon />,
      external: false,
    },
    {
      title: 'PNCP',
      href: 'https://pncp.gov.br/app/editais',
      icon: <SearchIcon />,
      external: true,
    },
    {
      title: 'Contracheque Online',
      href: parametersPortal?.urlPaycheck || '#',
      icon: <PaymentIcon />,
      external: true,
      disabled: !parametersPortal?.urlPaycheck,
    },
    {
      title: 'Nota Fiscal',
      href: parametersPortal?.urlNfse || '#',
      icon: <ReceiptIcon />,
      external: true,
      disabled: !parametersPortal?.urlNfse,
    },
    parametersPortal?.urlDaily && {
      title: 'Diárias',
      href: parametersPortal.urlDaily,
      icon: <FlightIcon />,
      external: true,
    },
    parametersPortal?.urlRevenue && {
      title: 'Receitas',
      href: parametersPortal.urlRevenue,
      icon: <TrendingUpIcon />,
      external: true,
    },
    parametersPortal?.urlExpenses && {
      title: 'Despesas',
      href: parametersPortal.urlExpenses,
      icon: <MoneyOffIcon />,
      external: true,
    },
    {
      title: 'GovHub-SIC',
      href: sicUrl(applicationData?.entity),
      icon: <InfoIcon />,
      external: true,
    },
    {
      title: 'GovHub-Ouvidoria',
      href: ouvUrl(applicationData?.entity),
      icon: <RecordVoiceOverIcon />,
      external: true,
    },
    cityNameNoSpaces && {
      title: 'e-SEI',
      href: `https://sip.${cityNameNoSpaces}.seibahia.ba.gov.br/login.php?sigla_orgao_sistema=${cityNameNoSpaces.toUpperCase()}&sigla_sistema=SEI`,
      icon: <DescriptionIcon />,
      external: true,
    },
    {
      title: 'e-GED',
      href: `https://airdoc.com.br/minuspaper?codEntidade=${cnpj}&empresa=3851`,
      icon: <FolderOpenIcon />,
      external: true,
    },
    parametersPortal?.urlRevenueExpense && {
      title: 'Receitas e Despesas',
      href: parametersPortal?.urlRevenueExpense,
      icon: <BalanceIcon />,
      external: true,
    },
    !parametersPortal?.urlRevenueExpense && {
      title: 'Receitas e Despesas',
      href: `http://airdoc.com.br/sgt?codEntidade=${cnpj}&empresa=3851`,
      icon: <BalanceIcon />,
      external: true,
    },
  ].filter(Boolean) as QuickAccessItem[];

  return (
    <PageSection>
      <Container maxWidth={false}>
        <Grid container spacing={4}>
          <Grid item xs={12}>
            <HomeSectionTitle>
              Acesso Rápido <hr />
            </HomeSectionTitle>
          </Grid>

          <Grid item xs={12}>
            <Grid container spacing={3}>
              {accessItems.map((item, index) => (
                <Grid key={index} item xs={6} sm={4} md={2.4}>
                  <LinkButtonCard {...item} />
                </Grid>
              ))}
            </Grid>
          </Grid>
        </Grid>
      </Container>
    </PageSection>
  );
}
